import React, { useState, useEffect } from 'react';
import { Card } from '../ui/card';
import { Rocket, Send, PlayCircle, CheckCircle2, AlertTriangle, TrendingUp, Loader2 } from 'lucide-react';
import { api } from '../../lib/api';

/**
 * KPIs onboarding — petite carte 5 chiffres pour le dashboard admin.
 */
const OnboardingKPIs = ({ days = 30 }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      try {
        const res = await api.get(`/admin/onboarding/kpis?days=${days}`);
        const body = await res.json();
        setData(body);
      } catch {
        setData(null);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [days]);

  if (loading) {
    return (
      <Card className="p-4">
        <Loader2 className="h-4 w-4 animate-spin text-tp-primary" />
      </Card>
    );
  }

  if (!data) return null;

  return (
    <Card className="p-4 md:p-5" data-testid="onboarding-kpis">
      <div className="flex items-center gap-2 mb-3">
        <Rocket className="h-4 w-4 text-tp-primary" />
        <h3 className="text-sm font-semibold uppercase tracking-wide text-tp-text">
          Onboarding · {days} derniers jours
        </h3>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-5 gap-3">
        <Stat icon={<Send className="h-3.5 w-3.5" />} label="Envoyés" value={data.sent} color="blue" />
        <Stat icon={<PlayCircle className="h-3.5 w-3.5" />} label="Démarrés" value={data.started} color="orange" />
        <Stat icon={<CheckCircle2 className="h-3.5 w-3.5" />} label="Terminés" value={data.completed} color="emerald" />
        <Stat icon={<AlertTriangle className="h-3.5 w-3.5" />} label="Docs manquants" value={data.missing_docs} color="red" />
        <Stat icon={<TrendingUp className="h-3.5 w-3.5" />} label="Taux complétion" value={`${data.completion_rate_pct}%`} color="primary" />
      </div>
    </Card>
  );
};

const Stat = ({ icon, label, value, color }) => {
  const colorMap = {
    blue: 'text-blue-700 bg-blue-50 border-blue-200',
    orange: 'text-orange-700 bg-orange-50 border-orange-200',
    emerald: 'text-emerald-700 bg-emerald-50 border-emerald-200',
    red: 'text-red-700 bg-red-50 border-red-200',
    primary: 'text-tp-primary bg-tp-primary/10 border-tp-primary/20',
  };
  return (
    <div className={`rounded-md p-2.5 border ${colorMap[color]}`}>
      <div className="flex items-center gap-1 text-[10px] uppercase tracking-wide font-semibold opacity-80">
        {icon}
        <span className="truncate">{label}</span>
      </div>
      <p className="text-xl font-bold mt-0.5">{value}</p>
    </div>
  );
};

export default OnboardingKPIs;
